import { Box, styled } from '@mui/material';

import { theme } from 'shared/styles';

export const StyledController = styled(Box)`
  margin-bottom: ${theme.spacing(3)};
  max-width: 28rem;
`;
